import { isDefined } from './type';
import {
  installmentLoanTypes,
  locLoanTypes,
  ProductTypeDisplayT,
  ProductTypeT,
} from '../types';

export const isLineOfCredit = (loanType?: ProductTypeT) => !!loanType && locLoanTypes.includes(loanType);
export const isInstallment = (loanType?: ProductTypeT) => !!loanType && installmentLoanTypes.includes(loanType);

export const productTypeDisplayFromType = (productType?: ProductTypeT): ProductTypeDisplayT => (
  isDefined(productType) && isLineOfCredit(productType) ? 'Line of Credit' : 'Installment'
);
